export default "__VITE_ASSET__Dku_3QDU__"